(() => {
  const ready = new WeakSet();
  const setup = (scope = document) => {
    const header = scope.querySelector('[data-gf-store-header]');
    if (!header || ready.has(header)) return;
    ready.add(header);
    const trigger = header.querySelector('[data-gf-menu-toggle]');
    const dialog = header.querySelector('[data-gf-navigation]');
    const rooms = [...dialog.querySelectorAll('[data-gf-nav-room]')];
    const panels = [...dialog.querySelectorAll('[data-gf-nav-panel]')];
    const roomList = dialog.querySelector('[data-gf-nav-rooms]');
    const back = dialog.querySelector('[data-gf-nav-back]');
    const title = dialog.querySelector('[data-gf-nav-title]');
    const mobile = window.matchMedia('(max-width:749px), (max-height:500px), (min-width:750px) and (max-width:1366px) and (hover:none) and (pointer:coarse)');
    const refined = window.matchMedia('(max-width:749px), (min-width:750px) and (max-width:1366px) and (hover:none) and (pointer:coarse)');
    const controller = new AbortController();
    const options = { signal: controller.signal };
    let selected = rooms[0];
    let scrollPosition = 0;
    let savedBody = null;
    const lock = () => {
      if (savedBody) return;
      scrollPosition = window.scrollY;
      savedBody = {};
      ['position', 'top', 'left', 'right', 'width', 'overflow'].forEach((key) => { savedBody[key] = document.body.style[key]; });
      Object.assign(document.body.style, { position: 'fixed', top: `-${scrollPosition}px`, left: '0', right: '0', width: '100%', overflow: 'hidden' });
    };
    const unlock = () => {
      if (!savedBody) return;
      Object.assign(document.body.style, savedBody);
      savedBody = null;
      window.scrollTo({ top: scrollPosition, behavior: 'instant' });
    };
    const resetStage = () => {
      dialog.dataset.stage = 'rooms';
      title.textContent = title.dataset.defaultTitle;
      back.hidden = true;
    };
    const choose = (room, focus = false) => {
      selected = room;
      rooms.forEach((button) => {
        const active = button === room;
        if (mobile.matches) button.removeAttribute('aria-selected');
        else button.setAttribute('aria-selected', String(active));
        button.tabIndex = mobile.matches || active ? 0 : -1;
      });
      panels.forEach((panel) => { panel.hidden = panel.dataset.gfNavPanel !== room.dataset.gfNavRoom; });
      if (mobile.matches) {
        dialog.dataset.stage = 'collections';
        title.textContent = room.querySelector('span').textContent;
        back.hidden = false;
        dialog.querySelector('.gf-nav-layout').scrollTop = 0;
        if (focus) (refined.matches ? title : back).focus({ preventScroll: true });
      }
    };
    const close = (restoreFocus = true) => {
      if (!dialog.open) return;
      dialog.close();
      trigger.setAttribute('aria-expanded', 'false');
      unlock();
      if (restoreFocus) trigger.focus({ preventScroll: true });
    };
    const arrange = () => {
      if (dialog.open) close();
      roomList.setAttribute('role', mobile.matches ? 'group' : 'tablist');
      if (mobile.matches) roomList.removeAttribute('aria-orientation');
      else roomList.setAttribute('aria-orientation', 'vertical');
      rooms.forEach((room) => {
        room.setAttribute('role', mobile.matches ? 'button' : 'tab');
        if (mobile.matches) room.removeAttribute('aria-selected');
        else room.setAttribute('aria-selected', String(room === selected));
        room.tabIndex = mobile.matches || room === selected ? 0 : -1;
      });
      panels.forEach((panel) => { panel.setAttribute('role', mobile.matches ? 'region' : 'tabpanel'); });
      resetStage();
    };
    trigger.addEventListener('click', () => {
      if (dialog.open) { close(); return; }
      resetStage();
      trigger.setAttribute('aria-expanded', 'true');
      if (mobile.matches) { lock(); dialog.showModal(); (refined.matches ? title : rooms[0]).focus({ preventScroll: true }); }
      else { dialog.show(); selected.focus(); }
    }, options);
    rooms.forEach((room) => room.addEventListener('click', () => choose(room, true), options));
    back.addEventListener('click', () => { resetStage(); selected.focus(); dialog.querySelector('.gf-nav-layout').scrollTop = 0; }, options);
    dialog.querySelector('[data-gf-nav-close]').addEventListener('click', () => close(), options);
    dialog.addEventListener('cancel', (event) => { event.preventDefault(); close(); }, options);
    dialog.addEventListener('close', () => { trigger.setAttribute('aria-expanded', 'false'); unlock(); }, options);
    dialog.addEventListener('keydown', (event) => {
      if (event.key === 'Escape') { event.preventDefault(); close(); return; }
      if (mobile.matches && event.key === 'Tab') {
        const targets = [...dialog.querySelectorAll('a[href],button:not([disabled]),input:not([disabled]):not([type=hidden]),[tabindex="0"]')].filter((element) => element.getClientRects().length > 0);
        const first = targets[0];
        const last = targets[targets.length - 1];
        if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first.focus(); }
        else if (event.shiftKey && document.activeElement === first) { event.preventDefault(); last.focus(); }
      }
      if (!mobile.matches && event.target.matches('[data-gf-nav-room]')) {
        let index = rooms.indexOf(event.target);
        if (event.key === 'ArrowDown') index = (index + 1) % rooms.length;
        else if (event.key === 'ArrowUp') index = (index - 1 + rooms.length) % rooms.length;
        else if (event.key === 'Home') index = 0;
        else if (event.key === 'End') index = rooms.length - 1;
        else if (event.key === 'ArrowRight') { event.preventDefault(); dialog.querySelector('[data-gf-nav-panel]:not([hidden]) a').focus(); return; }
        else return;
        event.preventDefault(); choose(rooms[index]); rooms[index].focus();
      }
    }, options);
    document.addEventListener('keydown', (event) => { if (event.key === 'Escape' && dialog.open) close(); }, options);
    document.addEventListener('click', (event) => {
      if (dialog.open && !mobile.matches && !dialog.contains(event.target) && !trigger.contains(event.target)) close(false);
    }, options);
    dialog.addEventListener('click', (event) => {
      if (event.target.closest('a')) close(false);
      if (mobile.matches && event.target === dialog) {
        const rect = dialog.getBoundingClientRect();
        if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) close();
      }
    }, options);
    mobile.addEventListener('change', arrange, options);
    refined.addEventListener('change', arrange, options);
    const measure = () => { header.style.setProperty('--gf-store-header-height', `${header.getBoundingClientRect().height}px`); dialog.style.setProperty('--gf-nav-viewport', `${window.visualViewport?.height || innerHeight}px`); dialog.style.setProperty('--gf-nav-top', `${window.visualViewport?.offsetTop || 0}px`); };
    window.visualViewport?.addEventListener('resize', measure, options);
    const observer = new ResizeObserver(measure);
    observer.observe(header);
    document.addEventListener('shopify:section:unload', (event) => {
      if (!event.target.contains(header)) return;
      close(false); observer.disconnect(); controller.abort();
    }, options);
    arrange(); measure();
  };
  const setupDirectory = () => {
    const directory = document.querySelector('[data-gf-directory]');
    if (!directory || ready.has(directory)) return;
    ready.add(directory);
    const showRoom = () => {
      const room = location.hash.replace('#gf-room-', '');
      const sections = [...directory.querySelectorAll('[data-gf-directory-room]')];
      const valid = sections.some((section) => section.dataset.gfDirectoryRoom === room);
      sections.forEach((section) => { section.hidden = !valid || section.dataset.gfDirectoryRoom !== room; });
      document.querySelector('[data-gf-directory-grid]').hidden = valid;
      directory.querySelectorAll('[data-gf-directory-link]').forEach((link) => {
        if (valid && link.dataset.gfDirectoryLink === room) link.setAttribute('aria-current', 'true');
        else link.removeAttribute('aria-current');
      });
      const all = directory.querySelector('[data-gf-directory-all]');
      if (valid) all.removeAttribute('aria-current'); else all.setAttribute('aria-current', 'true');
    };
    window.addEventListener('hashchange', showRoom);
    showRoom();
  };
  setup(); setupDirectory();
  document.addEventListener('shopify:section:load', (event) => { setup(event.target); setupDirectory(); });
})();


(() => {
  const configuration = document.querySelector('script[data-gf-whatsapp-label]');
  let scheduled = false;
  let protectedElements = [];
  let refreshElements = true;
  let iconSignature = '';
  const textMeasure = document.createElement('canvas').getContext('2d');
  const overlap = (a, b, gap = 8) => a.left < b.right + gap && a.right > b.left - gap && a.top < b.bottom + gap && a.bottom > b.top - gap;
  const visible = (element) => {
    const rect = element.getBoundingClientRect();
    const style = getComputedStyle(element);
    const closed = element.closest('details:not([open])');
    if (closed && !closed.querySelector(':scope > summary')?.contains(element)) return false;
    return rect.width > 1 && rect.height > 1 && style.display !== 'none' && style.visibility !== 'hidden' && !element.closest('[hidden], [inert], [aria-hidden="true"]');
  };
  const setAttribute = (element, name, value) => {
    if (value === null) { if (element.hasAttribute(name)) element.removeAttribute(name); }
    else if (element.getAttribute(name) !== value) element.setAttribute(name, value);
  };
  const schedule = () => {
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(sync);
  };
  const updateDock = (dock, link, row) => {
    if (!dock || !/^https?:\/\//i.test(link.href)) return false;
    let dockLink = dock.querySelector('.gf-chat-dock-link');
    if (!dockLink) {
      dockLink = document.createElement('a');
      dockLink.className = 'gf-chat-dock-link';
      const icon = document.createElement('span');
      icon.className = 'gf-chat-dock-icon';
      icon.setAttribute('aria-hidden', 'true');
      const copy = document.createElement('span');
      copy.className = 'gf-chat-dock-copy';
      const title = document.createElement('span');
      title.className = 'gf-chat-dock-title';
      title.textContent = configuration?.dataset.gfWhatsappLabel || row.querySelector('.whatsapp-text')?.textContent || 'WhatsApp';
      const action = document.createElement('span');
      action.className = 'gf-chat-dock-action';
      action.textContent = configuration?.dataset.gfWhatsappAction || 'WhatsApp';
      copy.append(title, action);
      const arrow = document.createElement('span');
      arrow.className = 'gf-chat-dock-arrow';
      arrow.textContent = '↗';
      arrow.setAttribute('aria-hidden', 'true');
      dockLink.append(icon, copy, arrow);
      dock.append(dockLink);
    }
    setAttribute(dockLink, 'href', link.href);
    setAttribute(dockLink, 'target', link.target || '_blank');
    setAttribute(dockLink, 'rel', 'noopener noreferrer');
    setAttribute(dockLink, 'aria-label', configuration?.dataset.gfWhatsappAccessible || link.getAttribute('aria-label') || 'WhatsApp');
    const artwork = row.querySelector('svg, img');
    if (artwork && (!dockLink.querySelector('.gf-chat-dock-icon').firstElementChild || iconSignature !== artwork.outerHTML)) {
      iconSignature = artwork.outerHTML;
      const clone = artwork.cloneNode(true);
      const identifiers = new Map();
      [clone, ...clone.querySelectorAll('[id]')].forEach((node) => {
        if (!node.id) return;
        const oldId = node.id;
        const newId = `gf-chat-dock-${oldId}`;
        identifiers.set(oldId, newId);
        node.id = newId;
      });
      [clone, ...clone.querySelectorAll('*')].forEach((node) => {
        [...node.attributes].forEach((attribute) => {
          let value = attribute.value;
          identifiers.forEach((newId, oldId) => {
            value = value.replaceAll(`url(#${oldId})`, `url(#${newId})`);
            if (value === `#${oldId}`) value = `#${newId}`;
          });
          if (value !== attribute.value) node.setAttribute(attribute.name, value);
        });
      });
      clone.setAttribute('aria-hidden', 'true');
      clone.setAttribute('focusable', 'false');
      dockLink.querySelector('.gf-chat-dock-icon').replaceChildren(clone);
    }
    if (!artwork) return false;
    if (dock.hidden) dock.hidden = false;
    return true;
  };
  const sync = () => {
    scheduled = false;
    const root = document.getElementById('whatsapp-widget-root');
    const link = root?.querySelector('#whatsapp-link');
    const row = link?.querySelector('.whatsapp-flex-container');
    const bubble = root?.querySelector('#chat-bubble');
    if (!root || !link || !row || !bubble) return;
    let label = row.querySelector('.whatsapp-text');
    if (!label) {
      label = document.createElement('span'); label.className = 'whatsapp-text'; row.prepend(label);
    }
    if (configuration?.dataset.gfWhatsappLabel && label.textContent !== configuration.dataset.gfWhatsappLabel) label.textContent = configuration.dataset.gfWhatsappLabel;
    if (configuration?.dataset.gfWhatsappAccessible) setAttribute(link, 'aria-label', configuration.dataset.gfWhatsappAccessible);
    const dock = document.querySelector('main .gf-product-page [data-gf-help-dock]');
    const dockReady = updateDock(dock, link, row);
    const active = document.activeElement;
    const textEntry = active?.isContentEditable || active?.matches('textarea') ||
      (active?.matches('input') && ['text', 'search', 'email', 'tel', 'url', 'password', 'number'].includes(active.type));
    const typing = Boolean(textEntry && !root.contains(active) && !dock?.contains(active));
    const overlay = [...document.querySelectorAll('dialog[open], .product-media-modal[open], .product-popup-modal[open], [aria-modal="true"], [data-gf-search-suggest]:not([hidden]), cart-drawer.active, .cart-notification.active')].some(visible);
    if (dock) {
      setAttribute(dock, 'data-gf-help-suppressed', typing || overlay ? '' : null);
      dock.inert = Boolean(typing || overlay);
    }
    const viewport = window.visualViewport;
    const viewportTop = viewport?.offsetTop || 0;
    const viewportBottom = viewportTop + (viewport?.height || innerHeight);
    const headerBottom = Math.max(viewportTop, document.querySelector('[data-gf-store-header]')?.getBoundingClientRect().bottom || 0);
    const inView = (element) => {
      if (!element || !visible(element)) return false;
      const rect = element.getBoundingClientRect();
      return rect.bottom > headerBottom + 8 && rect.top < viewportBottom - 8;
    };
    const purchase = dock?.parentElement?.querySelector('.product-form__buttons');
    const buying = Boolean(dockReady && (inView(purchase) || inView(dock)));
    let hide = typing || overlay || buying;
    let lift = null;
    let compact = root.hasAttribute('data-gf-chat-compact');
    if (!hide && !root.contains(active)) {
      if (refreshElements) {
        protectedElements = [...document.querySelectorAll('main a, main button, main input, main textarea, main select, main summary, main h1, main .price, main .card__information, main .gf-home-price, main .gf-home-category-label, footer a, .gf-store-footer a')];
        refreshElements = false;
      }
      const rects = protectedElements.filter((element) => !root.contains(element) && !dock?.contains(element) && visible(element)).map((element) => element.getBoundingClientRect()).filter((rect) => rect.bottom > headerBottom && rect.top < viewportBottom);
      // The natural floating size remains measurable while visibility is hidden.
      const measured = bubble.getBoundingClientRect();
      const labelStyle = getComputedStyle(label);
      if (textMeasure) textMeasure.font = labelStyle.font;
      const iconWidth = row.querySelector(':scope > div')?.getBoundingClientRect().width || measured.height;
      const labelWidth = (textMeasure?.measureText(label.textContent).width || label.textContent.length * 8) + ['paddingLeft','paddingRight','borderLeftWidth','borderRightWidth'].reduce((sum, key) => sum + (parseFloat(labelStyle[key]) || 0), 0);
      const fullWidth = Math.ceil(iconWidth + labelWidth + (parseFloat(getComputedStyle(row).gap) || 0));
      const margin = innerWidth < 750 ? 16 : innerWidth <= 1024 ? 20 : 24;
      const bar = document.querySelector('#PBarNextFrame, #preview-bar-iframe, iframe[name="preview-bar-iframe"]');
      const barRect = bar && visible(bar) ? bar.getBoundingClientRect() : null;
      // Shopify's preview iframe spans the screen; only its bottom toolbar is occupied.
      const bottom = barRect ? barRect.height < 200 ? Math.min(viewportBottom, barRect.top) : viewportBottom - (innerWidth < 750 ? 80 : 60) : viewportBottom;
      const baseTop = bottom - margin - measured.height;
      const candidates = [baseTop, ...rects.map((rect) => rect.top - measured.height - 10)].filter((top) => top >= headerBottom + 12 && top <= baseTop && baseTop - top <= 160).sort((a, b) => b - a);
      const safeTop = (width) => {
        const left = measured.right - width;
        return candidates.find((candidate) => !rects.some((rect) => overlap({left, right:left + width, top:candidate, bottom:candidate + measured.height}, rect)));
      };
      let top = safeTop(fullWidth);
      compact = top === undefined;
      if (compact) top = safeTop(iconWidth);
      if (top === undefined || measured.width <= 1 || measured.height <= 1) hide = true;
      else lift = `${Math.max(margin, innerHeight - top - measured.height)}px`;
    }
    setAttribute(root, 'data-gf-chat-hidden', hide ? '' : null);
    if (!root.contains(active)) setAttribute(root, 'data-gf-chat-compact', !hide && compact ? '' : null);
    setAttribute(root, 'data-gf-chat-state', buying ? 'docked' : typing || overlay ? 'suppressed' : hide ? 'paused' : compact ? 'compact' : 'floating');
    setAttribute(root, 'aria-hidden', hide ? 'true' : null);
    root.inert = hide;
    if (lift) { if (root.style.getPropertyValue('--gf-chat-lift') !== lift) root.style.setProperty('--gf-chat-lift', lift); }
    else if (!root.contains(active) && root.style.getPropertyValue('--gf-chat-lift')) root.style.removeProperty('--gf-chat-lift');
  };
  new MutationObserver(() => { refreshElements = true; schedule(); }).observe(document.body, {childList:true, subtree:true, attributes:true, attributeFilter:['open', 'hidden', 'aria-expanded']});
  const layout = new ResizeObserver(() => { refreshElements = true; schedule(); });
  const main = document.querySelector('main');
  if (main) layout.observe(main);
  ['focusin', 'focusout', 'change', 'shopify:section:load', 'shopify:section:unload'].forEach((event) => document.addEventListener(event, schedule));
  document.addEventListener('toggle', schedule, true);
  window.addEventListener('pageshow', schedule);
  window.addEventListener('resize', schedule);
  window.addEventListener('scroll', schedule, {passive:true});
  window.visualViewport?.addEventListener('resize', schedule);
  window.visualViewport?.addEventListener('scroll', schedule);
  document.fonts?.ready.then(schedule);
  sync();
})();
